// ---------------------------------------
// Navigation.js
// Handle navigation functions (dropdown, hamburger, ...)
// ---------------------------------------

import Navigation from 'nova-tn-frontend/source/scripts/modules/Navigation'
import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'

const NavigationExpand = {
	hamburgerButton: document.querySelector('.js-hamburger-button'),
	dropdownWrapper: document.querySelector('.c-header .dropdown-wrapper'),
	dropdownItem: document.querySelector('.c-header .dropdown-item'),
	navigationItems: document.querySelectorAll('.c-navigation .item'),

	NavigationExpand() {
		this.HandleDropdownMenu()
		this.HandleHoverMenu()
	},

	HandleDropdownMenu() {
		if (this.hamburgerButton) {
			this.hamburgerButton.addEventListener('click', () => {
				this.ToggleActiveClass(this.hamburgerButton)
				this.ToggleActiveClass(this.dropdownWrapper)
				document.documentElement.classList.toggle('has-nav-open')
			})
		}

		if (this.dropdownItem) {
			this.dropdownItem.addEventListener('show.bs.dropdown', () => {
				this.dropdownWrapper.classList.add('has-dropdown-open')
			})
			this.dropdownItem.addEventListener('hide.bs.dropdown', () => {
				this.dropdownWrapper.classList.remove('has-dropdown-open')
			})
		}
	},

	HandleHoverMenu() {
		if (this.navigationItems) {
			$(this.navigationItems).hover(
				function () {
					$(this).addClass('-open')
				},
				function () {
					$(this).removeClass('-open')
				}
			)
		}
	},

	ToggleActiveClass(element) {
		element.classList.toggle('is-active')
	},
}

// Skopírujeme všetko z originál Navigation
Object.assign(NavigationExpand, Navigation)

// Prepíšeme iba problémovú metódu BtnVsNavHandle
if (
	NavigationExpand.AppBtn &&
	typeof NavigationExpand.AppBtn.BtnVsNavHandle === 'function'
) {
	NavigationExpand.AppBtn.BtnVsNavHandle = (initCall = false) => {
		if (Utils.IsResponsive()) {
			return
		}

		const navWrap = document.querySelector('.c-header .c-navigation')
		const itemsWrap = document.querySelector(
			'.c-header .c-navigation .items'
		)
		const appsBanner = document.querySelector('.c-header .apps-banner')

		// ochrana pred null
		if (!navWrap || !itemsWrap || !appsBanner) {
			return
		}

		if (navWrap.clientWidth <= itemsWrap.clientWidth) {
			const isBannerTiny = appsBanner.classList.contains('-tiny')

			if (!isBannerTiny) {
				appsBanner.classList.add('-tiny')
			} else {
				const itemsVisible = itemsWrap.querySelectorAll(
					'.item:not(.-desktop-hidden)'
				)

				if (itemsVisible.length) {
					itemsVisible[itemsVisible.length - 1].classList.add(
						'-desktop-hidden'
					)
				}
			}

			if (initCall) {
				NavigationExpand.AppBtn.BtnVsNavHandle(true)
			}
		} else {
			const isBannerTiny = appsBanner.classList.contains('-tiny')
			const itemsHidden = itemsWrap.querySelectorAll(
				'.item.-desktop-hidden'
			)

			if (itemsHidden.length) {
				const firstHidden = itemsHidden[0]
				const firstHiddenWidth = firstHidden.clientWidth
				const possibleWidth =
					itemsWrap.clientWidth + firstHiddenWidth + 10

				if (possibleWidth <= navWrap.clientWidth) {
					firstHidden.classList.remove('-desktop-hidden')
				}
			}

			if (isBannerTiny && !itemsHidden.length) {
				appsBanner.classList.remove('-tiny')
				NavigationExpand.AppBtn.BtnVsNavHandle()
			}
		}
	}
}

window.Navigation = NavigationExpand
export default NavigationExpand
